import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UploadFieldMobile from "../atomicDesignMobile/atoms/UploadFieldMobile";
import useProSignupDocumentPanel from '../../../hooks/useProSignupDocumentPanel';
import JustificatifHelpDialog, { JustificatifType } from '../../pro/JustificatifHelpDialog';
import { getProDocumentUploadAccept } from '../../../utils/files/proDocumentUploadRules';

const SignUpPageMobileProPanel3 = () => {
	const { t } = useTranslation();
	const [helpType, setHelpType] = useState<JustificatifType | null>(null);
	const {
		userInfo,
		isThirdPanelValidated,
		loadingSignup,
		shouldSkipDocumentUploadStep,
		openedPanel,
		setOpenedPanel,
		sectionTitle,
		warningCompanyName,
		wrongFields,
		isMissingBackDialogOpen,
		handleFilesUpload,
		handleRemoveFile,
		handleValidate,
		handleMissingBackConfirm,
		handleMissingBackCancel,
	} = useProSignupDocumentPanel();
	const handleHelpFilesChange = (type: JustificatifType, files: FileList) => handleFilesUpload(type, files);

	return (
		<div
			style={{
				marginTop: 18,
				width: 277,
				height: openedPanel === 'documents' ? '' : 20,
				background: '#FFFFFF',
				borderRadius: 10,
				position: 'relative',
				padding: 12,
				boxShadow: '0px 1px 6px #00000029',
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					cursor: 'pointer',
				}}
				onClick={() => setOpenedPanel(openedPanel === 'documents' ? '' : 'documents')}
			>
					<div
						style={{
							height: 20,
							display: 'flex',
						flexDirection: 'row',
						gap: 8,
						position: 'relative',
					}}
				>
					{isThirdPanelValidated ? (
						<img
							src="/images/check-2.svg"
							alt="check"
							style={{
								width: 18,
								height: 16,
							}}
						/>
					) : (
						<div style={{ width: 18 }}/>
					)}
					<div
						style={{
							fontSize: 16,
							fontWeight: 'bold',
							display: 'flex',
							alignItems: 'center',
						}}
					>
						{sectionTitle}
					</div>
				</div>
				{openedPanel === 'documents' ? (
					<img
						src="/images/chevron-down.svg"
						alt="chevron-down"
						style={{ width: 16, height: 16, marginRight: 5 }}
					/>
				) : (
					<img
						src="/images/chevron-right.svg"
						alt="chevron-right"
						style={{
							width: 20,
							height: 20,
							marginRight: 5
						}}
					/>
				)}
			</div>

			{openedPanel === 'documents' && (
				<>
					<div
						style={{
							margin: '5px 10px 0 10px',
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						{shouldSkipDocumentUploadStep ? (
							<>
								<div style={{ height: 14 }}/>
								<div
									style={{
										padding: '14px 12px',
										display: 'flex',
										flexDirection: 'column',
										gap: 10,
										borderRadius: 10,
										background: '#FFF4EC',
										borderLeft: '4px solid #FF4D00',
										color: '#323E48',
									}}
								>
									<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
										<img src="/images/info.svg" alt="info" style={{ width: 18, height: 18 }} />
										<div style={{ fontSize: 13, fontWeight: 'bold', lineHeight: 1.3 }}>
											{t('thirdPanel:dead_end_info_title', {
												companyName: warningCompanyName,
											})}
										</div>
									</div>
									<div style={{ fontSize: 18, lineHeight: 1.45, whiteSpace: 'pre-line' }}>
										{t('thirdPanel:dead_end_info_message')}
									</div>
								</div>
								<div style={{ height: 16 }}/>
							</>
						) : (
							<>
								<div style={{ height: 22 }}/>
								<UploadFieldMobile
									label={t('thirdPanel:upload_company_registration')}
									helperText={t('thirdPanel:file_restrictions_company_registration')}
									accept={getProDocumentUploadAccept('companyRegistration')}
									onFilesChange={(files) => handleFilesUpload('companyRegistration', files)}
									uploadedFileNames={userInfo.documents?.companyRegistration?.map((file) => file.name)}
									onRemoveFile={(index) => handleRemoveFile('companyRegistration', index)}
									wrong={wrongFields.companyRegistration}
								wrongMessage={t('thirdPanel:wrong_company_registration')}
								onInfoLabel={t('thirdPanel:faq_companyRegistration_title')}
								emptyLabel={t('thirdPanel:upload_no_document')}
								dropPrefix={t('thirdPanel:upload_drop_prefix')}
								browseLabel={t('thirdPanel:upload_browse_action')}
								onInfoClick={() => setHelpType('companyRegistration')}
								/>
								<div style={{ height: 22 }}/>
								<UploadFieldMobile
									label={t('thirdPanel:upload_identity_card_front')}
									helperText={t('thirdPanel:file_restrictions_identity_card')}
									accept={getProDocumentUploadAccept('identityCard')}
									onFilesChange={(files) => handleFilesUpload('identityCard', files)}
									uploadedFileNames={userInfo.documents?.identityCard?.map((file) => file.name)}
									onRemoveFile={(index) => handleRemoveFile('identityCard', index)}
									wrong={wrongFields.identityCard}
								wrongMessage={t('thirdPanel:wrong_identity_card')}
								onInfoLabel={t('thirdPanel:faq_identityCard_title')}
								emptyLabel={t('thirdPanel:upload_no_document')}
								dropPrefix={t('thirdPanel:upload_drop_prefix')}
								browseLabel={t('thirdPanel:upload_browse_action')}
								onInfoClick={() => setHelpType('identityCard')}
								/>
								<div style={{ height: 22 }}/>
								<UploadFieldMobile
									label={t('thirdPanel:upload_identity_card_back')}
									helperText={t('thirdPanel:file_restrictions_identity_card')}
									accept={getProDocumentUploadAccept('identityCardBack')}
									onFilesChange={(files) => handleFilesUpload('identityCardBack', files)}
									uploadedFileNames={userInfo.documents?.identityCardBack?.map((file) => file.name)}
								onRemoveFile={(index) => handleRemoveFile('identityCardBack', index)}
								onInfoLabel={t('thirdPanel:faq_identityCardBack_title')}
								emptyLabel={t('thirdPanel:upload_no_document')}
								dropPrefix={t('thirdPanel:upload_drop_prefix')}
								browseLabel={t('thirdPanel:upload_browse_action')}
								onInfoClick={() => setHelpType('identityCardBack')}
									verticalLayout={true}
								/>
								<div style={{ height: 18 }}/>
								<div
									style={{
										padding: '10px 12px',
										display: 'flex',
										alignItems: 'center',
										gap: 10,
										borderRadius: 6,
										background: '#E8F5EA',
										borderLeft: '4px solid #2F6E3F',
										color: '#2F6E3F',
										fontSize: 10,
										lineHeight: 1.3,
									}}
								>
									<img src="/images/info.svg" alt="info" style={{ width: 16, height: 16 }} />
									<div>{t('thirdPanel:identity_card_tip')}</div>
								</div>
								<div style={{ height: 22 }}/>
							</>
						)}
						<button
								disabled={loadingSignup}
								style={{
									width: '100%',
									minHeight: 28,
									borderRadius: 5,
									backgroundColor: '#FF4D00',
									color: '#FFFFFF',
									border: 'none',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									fontSize: shouldSkipDocumentUploadStep ? 11 : 14,
									fontWeight: 'bold',
									cursor: loadingSignup ? 'not-allowed' : 'pointer',
									opacity: loadingSignup ? 0.7 : 1,
									textTransform: 'uppercase',
									lineHeight: 1.1,
									whiteSpace: 'normal',
									padding: '8px 8px',
								}}
							onClick={handleValidate}
						>
							{shouldSkipDocumentUploadStep
								? t('thirdPanel:dead_end_contact_cta')
								: t('thirdPanel:validate_button')}
						</button>
					</div>
					<Dialog
						open={isMissingBackDialogOpen}
						onClose={handleMissingBackCancel}
						PaperProps={{
							style: {
								width: 325,
								borderRadius: 18,
							},
						}}
					>
						<div
							style={{
								padding: '24px 18px',
								color: '#323E48',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								textAlign: 'center',
								gap: 12,
							}}
						>
							<div
								style={{
									width: 46,
									height: 46,
									borderRadius: '50%',
									background: '#FFF0E0',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<img src="/images/info.svg" alt="info" style={{ width: 20, height: 20 }} />
							</div>
							<div style={{ fontSize: 11, color: '#2F6E3F', background: '#E8F5EA', borderRadius: 999, padding: '4px 10px' }}>
								{t('thirdPanel:missing_identity_back_badge')}
							</div>
							<div style={{ fontSize: 16, fontWeight: 'bold', lineHeight: 1.25 }}>
								{t('thirdPanel:missing_identity_back_title')}
							</div>
							<div style={{ fontSize: 12, lineHeight: 1.45 }}>
								{t('thirdPanel:missing_identity_back_message')}
							</div>
							<div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
								<button
									style={{
										height: 44,
										padding: '0 14px',
										borderRadius: 10,
										background: '#FFFFFF',
										color: '#323E48',
										border: '1px solid #D9D9D9',
										fontSize: 11,
										fontWeight: 'bold',
										cursor: 'pointer',
										textTransform: 'uppercase',
									}}
									onClick={handleMissingBackConfirm}
								>
									{t('thirdPanel:missing_identity_back_confirm')}
								</button>
								<button
									style={{
										height: 44,
										padding: '0 14px',
										borderRadius: 10,
										background: '#FF4D00',
										color: '#FFFFFF',
										border: 'none',
										fontSize: 11,
										fontWeight: 'bold',
										cursor: 'pointer',
										textTransform: 'uppercase',
									}}
									onClick={handleMissingBackCancel}
								>
									{t('thirdPanel:missing_identity_back_cancel')}
								</button>
							</div>
						</div>
					</Dialog>
				</>
			)}
			<JustificatifHelpDialog
				open={helpType !== null}
				type={helpType}
				onClose={() => setHelpType(null)}
				onFilesChange={handleHelpFilesChange}
				compact
			/>
		</div>
	);
};

export default SignUpPageMobileProPanel3;
